import React from 'react';

interface RequiredIndicatorProps {
    show?: boolean; // Opcional para manter compatibilidade
}

/**
 * Componente para renderizar indicador de campo obrigatório
 * Uso: <RequiredIndicator /> ou <RequiredIndicator show={isRequired} />
 */
const RequiredIndicator: React.FC<RequiredIndicatorProps> = ({ show = true }) => {
    if (!show) return null;
    return <span className="text-red-500 ml-1">*</span>;
};

export default RequiredIndicator; 